import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../config/authConfig";
import { Button, Box, SvgIcon } from "@mui/material";

function MicrosoftIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path fill="#F25022" d="M1 1h10v10H1z" />
      <path fill="#7FBA00" d="M13 1h10v10H13z" />
      <path fill="#00A4EF" d="M1 13h10v10H1z" />
      <path fill="#FFB900" d="M13 13h10v10H13z" />
    </SvgIcon>
  );
}

export default function AzureLoginButton() {
  const { instance } = useMsal();

  const handleLogin = async () => {
    await instance.loginRedirect(loginRequest);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Button
        fullWidth
        variant="contained"
        startIcon={<MicrosoftIcon />}
        onClick={handleLogin}
        sx={{
          textTransform: "none",
          fontWeight: 500,
        }}
      >
        Sign in with Microsoft
      </Button>
    </Box>
  );
}
